import { useTranslation } from "react-i18next"
import {
	OrderStatusEnum,
	PayStatusEnum,
	type UserOrder,
	type UserOrderDetail,
} from "../schema"

const getStatusTextMap = (t: any): Record<OrderStatusEnum, string> => ({
	waitPay: t("order.storeGo.status.waitPay"),
	paid: t("order.storeGo.status.paid"),
	pushed: t("order.storeGo.status.pushed"),
	partSended: t("order.storeGo.status.partSended"),
	sended: t("order.storeGo.status.sended"),
	close: t("order.storeGo.status.close"),
	success: t("order.storeGo.status.success"),
	rejected: t("order.storeGo.status.rejected"),
	timeout: t("order.storeGo.status.timeout"),
})

// 支付状态映射
const getPayStatusTextMap = (t: any): Record<PayStatusEnum, string> => ({
	waitPay: t("order.payStatus.waitPay"),
	paid: t("order.payStatus.paid"),
	refunding: t("order.payStatus.refunding"),
	partRefund: t("order.payStatus.partRefund"),
	refund: t("order.payStatus.refund"),
})

export function ListOrderStatusStoreGo({ order }: { order: UserOrder }) {
	const { t } = useTranslation()
	const statusTextMap = getStatusTextMap(t)
	const payStatusTextMap = getPayStatusTextMap(t)

	// 如果是退款相关状态，优先显示退款状态
	if (
		order.payStatus === PayStatusEnum.REFUNDING ||
		order.payStatus === PayStatusEnum.PART_REFUND ||
		order.payStatus === PayStatusEnum.REFUND
	) {
		return (
			<span className="text-hint font-medium">
				{payStatusTextMap[order.payStatus]}
			</span>
		)
	}

	if (order.status === OrderStatusEnum.CLOSE) {
		return (
			<span className="text-hint font-medium">
				{t("order.storeGo.status.close")}
			</span>
		)
	}

	// 否则显示订单状态
	return statusTextMap[order.status]
}

export const DetailOrderStatusStoreGo = ({
	order,
}: {
	order: UserOrderDetail
}): string => {
	const { t } = useTranslation()
	const statusTextMap = getStatusTextMap(t)
	const payStatusTextMap = getPayStatusTextMap(t)

	if (
		order.payStatus === PayStatusEnum.REFUNDING ||
		order.payStatus === PayStatusEnum.PART_REFUND ||
		order.payStatus === PayStatusEnum.REFUND
	) {
		return payStatusTextMap[order.payStatus]
	}

	return statusTextMap[order.status]
}
